module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "striped": "",
      "stacked": "md",
      "bordered": _vm.table.bordered,
      "items": _vm.propsHistorico,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "inicio",
      fn: function(row) {
        return [_vm._v(_vm._s(_vm._f("moment")(row.value, "DD/MM/YYYY HH:mm")))]
      }
    }, {
      key: "usuario.ds_tipo_usuario",
      fn: function(row) {
        return [(row.value === 'ENTIDADE') ? _c('span', [_vm._v("Parceiro")]) : _vm._e(), _vm._v(" "), (row.value === 'FUNDACAO') ? _c('span', [_vm._v("FBB")]) : _vm._e()]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-401874f6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solicitacoes/modulos/historicoAntigo.vue
// module id = 1925
// module chunks = 1